<template>
  <div>
    <filter-bar
      v-if="loadReady && filtering"
      v-on:filter-set="filterSet"
      v-on:filter-reset="filterReset"
    ></filter-bar>
    <vuetable
      v-if="loadReady"
      ref="vuetable"
      :fields="columns"
      data-path=""
      pagination-path=""
      :css="css.table"
      :api-mode="false"
      :data="filteredRows"
    >
      <div slot="description" slot-scope="props">
        <p
          v-bind:class="{
            'text-truncate': truncateText,
            'd-inline-block': truncateText
          }"
          @click="resizeText(props.rowData)"
          style="width: 300px"
        >
          {{ props.rowData.description }}
        </p>
      </div>
      <div slot="image" slot-scope="props">
        <img
          v-if="props.rowData.image"
          :src="props.rowData.image"
          class="img-fluid z-depth-1"
          :alt="props.rowData.title"
          style="height: 100px"
        />
      </div>
      <div slot="active" slot-scope="props">
        <mdb-icon
          v-if="props.rowData.active === 0"
          icon="check"
          size="2x"
          class="red-text"
        />
        <mdb-icon v-else icon="check" size="3x" class="green-text" />
      </div>
      <div slot="deleted" slot-scope="props">
        <mdb-icon
          v-if="props.rowData.deleted === 0"
          icon="check"
          size="2x"
          class="red-text"
        />
        <mdb-icon v-else icon="check" size="3x" class="green-text" />
      </div>
      <div slot="invalidated" slot-scope="props">
        <mdb-icon
          v-if="props.rowData.invalidated === 0"
          icon="check"
          size="2x"
          class="red-text"
        />
        <mdb-icon v-else icon="check" size="3x" class="green-text" />
      </div>
      <div slot="control-slot" slot-scope="props">
        <mdb-btn-group vertical>
          <mdb-btn
            v-if="button1 !== null"
            @click="editContent(props.rowData)"
            color="blue"
            size="sm"
            style="width: 130px"
            >{{ button1 }}</mdb-btn
          >
          <mdb-btn
            v-if="button2 !== null"
            @click="archiveContentConfirm(props.rowData.id)"
            color="indigo"
            size="sm"
            style="width: 130px"
            >{{ button2 }}</mdb-btn
          >
          <mdb-btn
            v-if="button3 !== null"
            @click="specialContent(3, props.rowData)"
            color="aqua"
            size="sm"
            style="width: 130px"
            >{{ button3 }}</mdb-btn
          >
          <mdb-btn
            v-if="button4 !== null"
            @click="specialContent(4, props.rowData)"
            color="aqua"
            size="sm"
            style="width: 130px"
            >{{ button4 }}</mdb-btn
          >
        </mdb-btn-group>
      </div>
    </vuetable>
    <SmallModal
      :modal-show="archiveModal"
      :title="$t('archive_modal_title')"
      :description="$t('archive_modal_description')"
      :buttontext="$t('archive_modal_buttontext')"
      v-on:modal-cancelled="archiveCancelled"
      v-on:modal-ok="archiveContent"
    />
  </div>
</template>

<script>
import { mdbIcon, mdbBtn, mdbBtnGroup } from "mdbvue";
import Vuetable from "vuetable-2";
import FilterBar from "@/components/FilterBar.vue";
import SmallModal from "@/components/SmallModal.vue";
import VuetableCSS from "@/mixins/VuetableCSS.js";
export default {
  name: "DataTable",
  components: {
    Vuetable,
    FilterBar,
    SmallModal,
    mdbIcon,
    mdbBtn,
    mdbBtnGroup
  },
  props: {
    columns: Array,
    getcontentpath: String,
    archivecontentpath: String,
    jsonobject: String,
    archiveparam: String,
    filtering: {
      type: Boolean,
      default: true
    },
    button1: {
      type: String,
      default: null
    },
    button2: {
      type: String,
      default: null
    },
    button3: {
      type: String,
      default: null
    },
    button4: {
      type: String,
      default: null
    }
  },
  methods: {
    resizeText(rowData) {
      this.truncateText = !this.truncateText;
      console.log(rowData);
    },
    editContent(rowData) {
      this.$emit("button1", rowData);
    },
    specialContent(index, rowData) {
      this.$emit("special-content", index, rowData);
    },
    filterSet(filter) {
      this.filteredRows = this.rows.filter(function(content) {
        if (content.hasOwnProperty("name")) {
          try {
            return (
              content.name.toLowerCase().search(filter.toLowerCase()) != -1
            );
          } catch (error) {
            console.log(error);
          }
        } else {
          return content.title.toLowerCase().search(filter.toLowerCase()) != -1;
        }
      });
      this.$refs.vuetable.refresh();
    }, 
    filterReset() {
      this.filteredRows = this.rows;
      this.$refs.vuetable.refresh();
    },
    removeContent(id) {
      this.rows = this.rows.filter(function(content) {
        return content.id != id;
      });
      this.filteredRows = this.filteredRows.filter(function(content) {
        return content.id != id;
      });
    },
    archiveContentConfirm(id) {
      this.toBeArchivedId = id;
      this.archiveModal = true;
    },
    archiveCancelled() {
      this.archiveModal = false;
    },
    archiveContent() {
      this.archiveModal = false;
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        [this.archiveparam]: this.toBeArchivedId
      });

      this.$http
        .post(this.archivecontentpath, this.postdata)
        .then(response => {
          if (response.status == 200) {
            this.removeContent(response.data[this.archiveparam]);
            this.$notify.success({
              message: this.$t("archive_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            message: this.$t("archive_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort
          });
          console.log(error);
        });
    }
  },
  data: () => ({
    loadReady: false,
    archiveModal: false,
    toBeArchivedId: 0,
    search: "",
    rows: [],
    filteredRows: [],
    css: VuetableCSS,
    truncateText: true
  }),
  mounted() {
    this.$notify.info({
      message: this.$t("fetching_content"),
      position: "top right",
      timeOut: this.$store.state.notifytimeoutmedium
    });
    this.$http
      .get(this.getcontentpath + this.$store.getters.getToken)
      .then(response => {
        if (response.status == 200) {
          this.rows = response.data[this.jsonobject];
          this.filteredRows = this.rows;
          this.loadReady = true;
          this.$emit("load-ready");
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        } else {
          this.$notify.error({
            message: this.$t("content_not_loaded"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort
          });
        }
        this.$notify.removeAll();
      })
      .catch(error => {
        this.$notify.removeAll();
        this.$root.$emit("session_failed");
        return error;
      })
      .finally();
  }
};
</script>
